import React from 'react';
import { Spinner, SIZE } from 'baseui/spinner';
import useStyles from '../../useStyles';
import { LOADING_MESSAGES } from '../../constants';
import { LoadingKind } from '../../types';

// The live region is always mounted so screen readers announce the message when it appears
const StatusLine: React.FC<{ loading: LoadingKind }> = ({ loading }) => {
	const { classes } = useStyles();
	return (
		<div role='status' aria-live='polite' className={classes.status}>
			{loading && (
				<>
					<Spinner $size={SIZE.small} />
					<span>{LOADING_MESSAGES[loading]}</span>
				</>
			)}
		</div>
	);
};

export default StatusLine;
